import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'LandingPageForm'

export const RESET_LANDING_PAGE = `${typeKey}/RESET_CAL_FOR_ACTION`
export const CHANGE_LANDING_PAGE_PROPERTY = `${typeKey}/CHANGE_LANDING_PAGE_PROPERTY`

export const GET_LANDING_PAGE_ASYNC = createAsyncTypes('GET_LANDING_PAGE', typeKey)
export const ADD_LANDING_PAGE_ASYNC = createAsyncTypes('ADD_LANDING_PAGE', typeKey)
export const EDIT_LANDING_PAGE_ASYNC = createAsyncTypes('EDIT_LANDING_PAGE', typeKey)
